export const container = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundColor: '#FAFAFA',
  p: 3,
  gap: 1,
  '&>*': {
    width: '100%',
  },
};

export const btn = {
  backgroundColor: '#006DFF !important',
  '&:hover': {
    backgroundColor: '#0528A0 !important',
  },
};
